module.exports = __webpack_public_path__ + "img/sb.c23eab6d.svg";